import {TextInput} from '@/components-v2'
import {useEffect, useState} from 'react'

/** A position is committed on Enter/blur, never on each keystroke. */
export const OrderPositionInput = ({itemKey, position, maxPosition, disabled, onCommit, onInputStateChange}) => {
  const [value, setValue] = useState(String(position))
  const [error, setError] = useState('')

  useEffect(() => {
    setValue(String(position))
    setError('')
    onInputStateChange(itemKey, false, false)
  }, [position, itemKey, onInputStateChange])

  // An unmounted input must not leave a dirty/invalid flag behind.
  useEffect(() => () => onInputStateChange(itemKey, false, false), [itemKey, onInputStateChange])

  const isValid = text =>
    /^\d+$/.test(text) && Number.isSafeInteger(Number(text)) && Number(text) >= 1 && Number(text) <= maxPosition

  const commit = () => {
    if (!isValid(value)) {
      setError(`Enter a whole number from 1 to ${maxPosition}.`)
      onInputStateChange(itemKey, value !== String(position), true)
      return false
    }
    const nextPosition = Number(value)
    if (nextPosition !== position) onCommit(nextPosition)
    setValue(String(nextPosition))
    setError('')
    onInputStateChange(itemKey, false, false)
    return true
  }

  const resetValue = () => {
    setValue(String(position))
    setError('')
    onInputStateChange(itemKey, false, false)
  }

  return (
    <div className="catalog-position-input" onClick={event => event.stopPropagation()}>
      <TextInput
        id={`catalog-position-${encodeURIComponent(itemKey)}`}
        inputSize="small"
        inputMode="numeric"
        pattern="[0-9]*"
        value={value}
        disabled={disabled}
        error={error || undefined}
        onUpdate={next => {
          if (!/^\d*$/.test(next)) return
          setValue(next)
          setError('')
          onInputStateChange(itemKey, next !== String(position), !isValid(next))
        }}
        onBlur={commit}
        onKeyDown={event => {
          event.stopPropagation()
          if (event.key === 'Enter') {
            event.preventDefault()
            commit()
          } else if (event.key === 'Escape') {
            event.preventDefault()
            resetValue()
          }
        }}
      />
    </div>
  )
}
